import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetEicMessageResponse, UpdateConsentInput } from '@buy-viasat/types/build/bv';
import { CartProduct } from '@buy-viasat/types/build/bv/generated/mock-schema-types';

export const initialConsentState = {
  eicMessages: [],
  queryLoading: false,
  queryError: false,
  mutationLoading: false,
  cartProducts: null,
  updateConsentLoading: false,
};

export type ConsentState = {
  eicMessages: GetEicMessageResponse[];
  queryLoading: boolean;
  queryError: boolean;
  mutationLoading: boolean;
  cartProducts: CartProduct[] | null;
  updateConsentLoading: boolean;
};

const consentSlice = createSlice({
  name: 'consent',
  initialState: initialConsentState,
  reducers: {
    getEicMessages(state: ConsentState): void {
      state.queryLoading = true;
      state.queryError = false;
    },
    setEicMessages(state: ConsentState, action): void {
      state.eicMessages = action.payload;
      state.queryLoading = false;
    },
    setEicMessagesError(state: ConsentState, action): void {
      state.queryLoading = false;
      state.queryError = action.payload;
    },
    setEicMessagesLoading(state: ConsentState, action): void {
      state.queryLoading = action.payload;
    },
    setCartProducts(state: ConsentState, action): void {
      state.cartProducts = action.payload.cartProducts;
    },
    updateConsentLoading(state: ConsentState, action: PayloadAction<boolean>): void {
      state.updateConsentLoading = action.payload;
    },
    setUpdateConsent(state: ConsentState, action: PayloadAction<UpdateConsentInput>): void {
      state.updateConsentLoading = true;
    },
  },
});

export const { actions: consentActions, reducer: consentReducer, name: consentKey } = consentSlice;
